var _style, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _path22, _circle2, _circle3, _circle4, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect2, _path37, _polygon, _path38, _path39, _polygon2, _path40, _path41, _path42, _path43, _path44, _path45, _circle5, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g, _g2, _path61, _g3, _path62;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 692 499.9",
    style: {
      enableBackground: "new 0 0 692 499.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#3F3D56;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#2F2E41;}\n\t.st4{fill:#A0616A;}\n\t.st5{fill:#5784BB;}\n\t.st6{fill:#F2F2F2;}\n\t.st7{fill:#FFA5D8;}\n\t.st8{fill:#BE9DDF;}\n\t.st9{fill:#E6E6E6;}\n\t.st10{fill:#FFB8B8;}\n\t.st11{fill:#F1F1F1;}\n\t.st12{fill:none;stroke:#3F3D56;stroke-width:2;stroke-miterlimit:10;}\n\t.st13{fill:#575A89;}\n\t.st14{fill:#FFB9B9;}\n\t.st15{opacity:0.1;enable-background:new    ;}\n\t.st16{fill:#575A88;}\n\t.st17{fill:#FFB6B6;}\n\t.st18{opacity:0.2;enable-background:new    ;}\n\t.st19{opacity:0.5;fill:#FFA5D8;enable-background:new    ;}\n\t.st20{fill:#FF6584;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691,496H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h690c0.6,0,1,0.4,1,1S691.6,496,691,496z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622.7,321.6h-406c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5h11.5v155.5c0,3.6,2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5 l0.1-155.5h355.9v155.5c0,3.6,2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5v-152l1.9-3.4h10.6c3.6,0,6.5-2.9,6.5-6.5S626.3,321.6,622.7,321.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.8,325h-123c-5,0-9-4-9-9v-67.7c0-5,4-9,9-9h123c5,0,9,4,9,9V316C450.8,321,446.8,325,441.8,325z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M441.8,246.3h-123c-1.1,0-2.1,0.9-2.1,2.1v67.7c0,1.1,0.9,2.1,2.1,2.1h123c1.1,0,2.1-0.9,2.1-2.1v-67.7 C443.9,247.2,442.9,246.3,441.8,246.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M390.8,294.2c0,0-14.7-3.4-22.8,2.8s10.3,20.4,10.3,20.4L390.8,294.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 381,
    cy: 273.9,
    r: 13.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.3,254.4c1.9-3.2,5.4-5.1,9.1-4.9c1.9,0.2,3.8,0.8,5.5,1.5l9.1,3.5c2.3,0.9,4.9,2,5.9,4.3 c0.9,2.1,0.2,4.6-0.5,6.8l-3.4,10.6c-0.4-2.4-1-4.7-1.9-7s-2.6-4.2-4.7-5.4c-2.4-1.2-5.1-1.2-7.8-1.1c-3.7,0.2-7.8,0.7-10.5,3.3 c-1.4,1.5-2.4,3.4-2.8,5.4s-0.6,4.1-0.6,6.1c-1.5-2.6-2.8-5.4-3.9-8.3c-0.9-2.1-1.3-4.4-1.4-6.7c-0.1-2.3,0.7-4.6,2.2-6.4 c1.5-1.8,3.9-2.5,6.2-2L370.3,254.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M414.2,306.3c-0.3-1-1.1-1.7-2.1-1.8c0,0-0.1,0-0.1-0.1l-20.7-11.6c-1.2-0.7-2.8-0.3-3.5,0.9l-5.7,9.2l-8.5-8.5 l-0.1-0.1c-0.9-0.9-2.3-1-3.4-0.3l-17,11.9H353c-1.7,0.3-2.9,1.7-3,3.4l-0.4,8.9h68L414.2,306.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M452.2,316.8H439c0-0.8-0.6-1.4-1.4-1.4l0,0h-4.1c-0.8,0-1.4,0.6-1.4,1.4H428c0-0.8-0.6-1.4-1.4-1.4h-4.1 c-0.8,0-1.4,0.6-1.4,1.4l0,0H417c0-0.8-0.6-1.4-1.4-1.4l0,0h-4.1c-0.8,0-1.4,0.6-1.4,1.4H406c0-0.8-0.6-1.4-1.4-1.4h-4.1 c-0.8,0-1.4,0.6-1.4,1.4l0,0H395c0-0.8-0.6-1.4-1.4-1.4l0,0h-4.1c-0.8,0-1.4,0.6-1.4,1.4l0,0H384c0-0.8-0.6-1.4-1.4-1.4h-4.1 c-0.8,0-1.4,0.6-1.4,1.4H373c0-0.8-0.6-1.4-1.4-1.4l0,0h-4.1c-0.8,0-1.4,0.6-1.4,1.4l0,0H362c0-0.8-0.6-1.4-1.4-1.4l0,0h-4.1 c-0.8,0-1.4,0.6-1.4,1.4H351c0-0.8-0.6-1.4-1.4-1.4h-4.1c-0.8,0-1.4,0.6-1.4,1.4l0,0H340c0-0.8-0.6-1.4-1.4-1.4l0,0H334 c-0.8,0-1.4,0.6-1.4,1.4h-4.1c0-0.8-0.6-1.4-1.4-1.4H323c-0.8,0-1.4,0.6-1.4,1.4l0,0h-13.1c-2.3,0-4.1,1.9-4.1,4.2 c0,2.3,1.9,4.1,4.1,4.1h143.7c2.3,0,4.1-1.9,4.1-4.2C456.3,318.6,454.4,316.8,452.2,316.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M287.1,292.7v27.5h-69c-7.6,0.3-14-5.7-14.2-13.3s5.7-14,13.3-14.2c0.3,0,0.6,0,1,0H287.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M288.8,320c0,0.6-0.5,1.1-1.1,1.1h-70.8c-8,0-14.5-6.5-14.5-14.5s6.5-14.5,14.5-14.5h70.8 c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1h-70.8c-6.8,0-12.4,5.6-12.4,12.4s5.5,12.4,12.4,12.4h70.8 C288.3,318.9,288.8,319.4,288.8,320z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.1,299H213c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C287.3,298.9,287.2,299,287.1,299z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.1,304.1H213c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C287.3,304,287.2,304.1,287.1,304.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.1,309.2H213c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C287.3,309.1,287.2,309.2,287.1,309.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.1,314.3H213c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C287.3,314.2,287.2,314.3,287.1,314.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.1,263.7v27.5h-69c-7.6,0.3-14-5.7-14.2-13.3s5.7-14,13.3-14.2c0.3,0,0.6,0,1,0H274.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.8,291c0,0.6-0.5,1.1-1.1,1.1h-70.8c-8,0-14.5-6.5-14.5-14.5s6.5-14.5,14.5-14.5h70.8 c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1h-70.8c-6.8,0-12.4,5.5-12.4,12.4c0,6.8,5.5,12.4,12.4,12.4h70.8 C275.3,289.9,275.8,290.4,275.8,291z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,270H200c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C274.3,269.9,274.2,270,274.1,270z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,275.1H200c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C274.3,275,274.2,275.1,274.1,275.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,280.2H200c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C274.3,280.1,274.2,280.2,274.1,280.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.1,285.3H200c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C274.3,285.2,274.2,285.3,274.1,285.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M354.3,418v-24c0-2.2-1.8-4-4-4h-91c-2.2,0-4,1.8-4,4v24H354.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 255.3,
    y: 427,
    className: "st5",
    width: 99,
    height: 31
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M255.3,467v24c0,2.2,1.8,4,4,4h91c2.2,0,4-1.8,4-4v-24H255.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 304.3,
    cy: 405,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 304.3,
    cy: 445,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 304.5,
    cy: 484.2,
    r: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M343.1,362.7v27.5h-69c-7.6,0.3-14-5.7-14.2-13.3c-0.3-7.6,5.7-14,13.3-14.2c0.3,0,0.6,0,1,0H343.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.8,390c0,0.6-0.5,1.1-1.1,1.1h-70.8c-8,0-14.5-6.5-14.5-14.5s6.5-14.5,14.5-14.5l0,0h70.8 c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1h-70.8c-6.8,0-12.4,5.6-12.4,12.4s5.5,12.4,12.4,12.4h70.8 C344.3,388.9,344.8,389.4,344.8,390z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.1,369H269c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C343.3,368.9,343.2,369,343.1,369L343.1,369z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.1,374.1H269c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C343.3,374,343.2,374.1,343.1,374.1L343.1,374.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.1,379.2H269c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C343.3,379.1,343.2,379.2,343.1,379.2L343.1,379.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.1,384.3H269c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2l0,0h74.1c0.1,0,0.2,0.1,0.2,0.2 C343.3,384.2,343.2,384.3,343.1,384.3L343.1,384.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M250.1,183V7.5c0-4.2,3.4-7.5,7.5-7.5h138.7c4.2,0,7.5,3.4,7.5,7.5V183c0,4.2-3.4,7.5-7.5,7.5H257.6 C253.5,190.5,250.1,187.2,250.1,183z M257.6,1.7c-3.2,0-5.8,2.6-5.9,5.9V183c0,3.2,2.6,5.8,5.9,5.9h138.7c3.2,0,5.8-2.6,5.8-5.9V7.5 c0-3.2-2.6-5.8-5.8-5.9H257.6V1.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.8,133.5v-36c0-2.1,1.7-3.8,3.8-3.8h30.5c2.1,0,3.8,1.7,3.8,3.8v36c0,2.1-1.7,3.8-3.8,3.8h-30.5 C355.5,137.3,353.8,135.6,353.8,133.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.1,74.6V18.9c0-3.2,4.2-5.9,9.3-5.9h74.6c5.1,0,9.3,2.6,9.3,5.9v55.7c0,3.2-4.2,5.9-9.3,5.9h-74.6 C272.2,80.5,268.1,77.9,268.1,74.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M290.8,148.3v-36c0-2.1,1.7-3.8,3.8-3.8H325c2.1,0,3.8,1.7,3.8,3.8v36c0,2.1-1.7,3.8-3.8,3.8h-30.5 C292.4,152,290.8,150.4,290.8,148.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.6,313h-31.4c-0.3,0-0.6,0.1-0.9,0.2l-7.9,4c-0.7,0.3-1.1,1.2-0.8,1.9c0.1,0.3,0.4,0.6,0.8,0.8l7.9,4 c0.3,0.1,0.6,0.2,0.9,0.2h31.4c0.9,0.1,1.7-0.6,1.7-1.5v-7.9C507.2,313.7,506.5,313,505.6,313z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M507.3,314.6v7.9c-0.1,0.9-0.8,1.6-1.7,1.5h-6.3v-11h6.3C506.5,313,507.2,313.7,507.3,314.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M505.3,253.6c5.6-2.4,12.1,0.2,14.5,5.7c0.2,0.4,0.3,0.8,0.4,1.2c0.1,0.5,0.2,0.9,0.3,1.4l43.9,21.8l10.2-6.7 l12.7,14.6l-15.5,12.6c-3.8,3.1-9.2,3.3-13.3,0.5l-44.6-30.8c-0.3,0.1-0.7,0.3-1,0.4c-5.8,1.8-12-1.5-13.7-7.3 c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.4-0.1-0.9-0.2-1.3C498.4,259.8,501.1,255.5,505.3,253.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M596.8,387.8h-48c0,1.4-49.5,2.5-49.5,2.5c-0.8,0.6-1.5,1.3-2.1,2c-1.9,2.2-2.9,5.1-2.9,8v2 c0,6.9,5.6,12.5,12.5,12.5h90c6.9,0,12.5-5.6,12.5-12.5v-2C609.3,393.4,603.7,387.8,596.8,387.8z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 544.6,
    y: 414.3,
    className: "st1",
    width: 13,
    height: 84
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M507.6,497.8c0,1.4,19.7,0.5,44,0.5s44,0.9,44-0.5s-19.7-12.5-44-12.5S507.6,496.4,507.6,497.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "519.4,488 507.1,488 501.3,456.2 519.4,456.2 "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M522.5,499.9H483v-0.5c0-8.5,6.9-15.4,15.4-15.4l0,0l0,0h24.1V499.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M501,468.3l-24.4-54.8c-4.2-9.6-0.4-20.8,8.8-25.8l53-28.4l24.2-2.1l22.3-2l0.2,0.3c0.2,0.3,5,8.6,1.8,17.7 c-2.5,6.9-8.9,12.3-19,16c-23.7,8.7-51.1,16.1-61.8,18.9c-1,0.2-1.8,0.9-2.2,1.8c-0.5,0.9-0.5,1.9-0.2,2.8l22.7,51 c0.9,2.3-0.3,4.9-2.7,5.8c-0.4,0.1-0.7,0.2-1.1,0.3l-17,1.2c-0.1,0-0.3,0-0.4,0C503.3,470.9,501.7,469.9,501,468.3z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "525.4,488 513.1,488 507.3,456.2 525.4,456.2 "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M528.5,499.9H489v-0.5c0-8.5,6.9-15.4,15.4-15.4l0,0l0,0h24.1V499.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M508,471.3l-24.4-54.8c-4.2-9.6-0.4-20.8,8.8-25.8l53-28.4l24.2-2.1l22.3-2l0.2,0.3c0.2,0.3,5,8.6,1.8,17.7 c-2.5,6.9-8.9,12.3-19,16c-23.7,8.7-51.1,16.1-61.8,18.9c-1,0.2-1.8,0.9-2.2,1.8c-0.5,0.9-0.5,1.9-0.2,2.8l22.7,51 c0.9,2.3-0.3,4.9-2.7,5.8c-0.4,0.1-0.7,0.2-1.1,0.3l-17,1.2c-0.1,0-0.3,0-0.4,0C510.3,473.9,508.7,472.9,508,471.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.8,303.8c-10.3-13.7-18.4-28.8-24.1-44.9c-0.7-2,0.2-4.2,2-5.2l35.1-18.8c1.2-0.6,2.5-0.7,3.7-0.2 s2.1,1.6,2.5,2.9c4.1,15.5,11.8,29.9,22.4,41.9c0.9,1,1.3,2.3,1,3.6c-0.2,1.3-1,2.4-2.2,3L501.3,305 C499.4,306,497.1,305.5,495.8,303.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M498.2,302c0.4,0.5,1.1,0.6,1.6,0.3l35.1-18.8c0.3-0.2,0.6-0.5,0.7-0.9c0.1-0.4,0-0.8-0.3-1.1 c-11-12.4-18.9-27.1-23.1-43.1c-0.1-0.4-0.4-0.7-0.8-0.9s-0.8-0.1-1.1,0l-35.1,18.8c-0.5,0.3-0.8,0.9-0.6,1.5 C480.2,273.7,488.1,288.6,498.2,302z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M612.6,298.8l-27.5,10.5l-6.7-18.7c-1.8-5.1,0.3-10.8,5-13.5l0,0c4.8-2.7,10.8-1.5,14.3,2.8L612.6,298.8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M542.6,372.8c-1.2-0.8-1.9-2.1-2.1-3.5c-3.5-32.9-1.1-58.7,7.5-78.7c3.1-7,9.2-12.2,16.6-14.2l22.2-1.1l0.1,0.1 c10.3,5,16.1,16.3,14.2,27.6c-7.2,18.9-13.1,38.5-8.6,54.3c0.4,1.3,0.2,2.8-0.5,4s-1.8,2-3.1,2.3l-42.4,10.1 C545.2,373.9,543.7,373.6,542.6,372.8L542.6,372.8z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 579.4,
    cy: 242.3,
    r: 24.6
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.2,261.8l-19.1,8.4c-1.5,0.7-3.3,0-4-1.5l-0.5-1.1c-0.7-1.5,0-3.3,1.5-4l19.1-8.4c1.5-0.7,3.3,0,4,1.5 l0.5,1.1C513.4,259.3,512.8,261.1,511.2,261.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.2,274.8l-19.1,8.4c-1.5,0.7-3.3,0-4-1.5l-0.5-1.1c-0.7-1.5,0-3.3,1.5-4l19.1-8.4c1.5-0.7,3.3,0,4,1.5 l0.5,1.1C520.4,272.3,519.8,274.1,518.2,274.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M533,325.6l-42.7-33.7c-0.3,0.1-0.7,0.2-1,0.3c-3,0.7-6.3,0.1-8.8-1.7c-2.6-1.8-4.3-4.6-4.6-7.7 c-0.6-5.1,2.4-9.9,7.2-11.6c5.7-2.1,12,0.9,14.1,6.6c0.1,0.4,0.3,0.8,0.4,1.2c0.1,0.5,0.2,1,0.2,1.5l42.5,24.5l10.6-6.1l11.7,15.3 l-16.4,11.7C542.1,328.7,536.8,328.5,533,325.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M567.7,318.9l-24.3-16.6l11.4-16.2c3.1-4.4,9-6,13.9-3.6l0,0c5,2.4,7.5,8,5.9,13.3L567.7,318.9z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M570.4,238.7c-6.3,4.3-14.6,8.8-21,4.2c-4.2-3-5.6-8.6-3.9-13.5c3.1-8.8,11.6-12.7,19.7-15.7 c10.5-3.9,22-7,32.9-4.2s20.5,13.3,18.5,24.4c-1.6,8.9-10,16.3-8.8,25.2c1.2,9,11.3,13.8,20.3,15.4s19,2.1,25.4,8.6 c8.2,8.2,6.2,22.9-1.6,31.5s-19.4,12.6-30.7,15.2c-15,3.5-31.1,5.4-45.3-0.5s-25.3-21.7-21.1-36.5c1.7-6.3,5.8-11.5,9.8-16.7 s8-10.5,9.5-16.8c1.3-5.3,0.3-11.4-3.2-15.3c-1.3-1.4-1.5-3.5-0.6-5.2L570.4,238.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M109.1,358c-12.9,4.5-27.2,2-37.7-6.6C58.1,340.3,54,322,50.6,305.1c-3.3-16.7-6.6-33.4-10-50l20.9,14.4 c15,10.3,30.4,21,40.8,36s14.9,35.4,6.6,51.6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107.3,418.6c2.1-15.4,4.3-31,2.8-46.5c-1.3-13.8-5.5-27.3-14.1-38.4c-4.6-5.9-10.1-10.9-16.4-14.8 c-1.6-1-3.1,1.6-1.5,2.6c10.9,6.9,19.3,17,24,29c5.2,13.3,6.1,27.8,5.2,41.9c-0.5,8.5-1.7,17-2.9,25.5c-0.2,0.8,0.3,1.6,1,1.8 C106.2,419.8,107.1,419.4,107.3,418.6L107.3,418.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M86.9,391.3c-5.5,8.4-15,13.3-25.1,12.9c-12.7-0.6-23.3-9.5-32.8-17.9L1,361.6l18.6-0.9 c13.4-0.6,27.1-1.2,39.9,2.9s24.5,14.1,26.9,27.3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113.3,427.4c-10.2-18-22-38-43-44.4c-5.9-1.8-12-2.4-18.1-1.9c-1.9,0.2-1.4,3.1,0.5,3 c10.2-0.8,20.4,1.9,28.9,7.6c8.1,5.5,14.5,13.3,19.9,21.4c3.3,5,6.2,10.2,9.2,15.4C111.5,430.3,114.2,429.1,113.3,427.4L113.3,427.4 z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129.5,446.4c-0.7-8.1-5.8-15.1-13.3-18.2v-10.4H98.8v10.7c-7.1,3.3-11.9,10.1-12.6,17.9L82,494h51.6 L129.5,446.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M23,218V42.5c0-4.2,4.6-7.5,10.2-7.5H221c5.7,0,10.2,3.4,10.2,7.5V218c0,4.2-4.6,7.5-10.2,7.5H33.2 C27.6,225.5,23,222.2,23,218z M33.2,36.7c-4.3,0-7.9,2.6-8,5.9V218c0,3.2,3.5,5.8,8,5.9H221c4.3,0,7.9-2.6,7.9-5.9V42.5 c0-3.2-3.5-5.8-7.9-5.9H33.2V36.7z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.8,99.3v-36c0-2.1,1.7-3.8,3.8-3.8h30.5c2.1,0,3.8,1.7,3.8,3.8v36c0,2.1-1.7,3.8-3.8,3.8h-30.5 C173.5,103.1,171.8,101.4,171.8,99.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.6,110.4v-51c0-2.9,4.4-5.4,9.8-5.4h78.8c5.4,0,9.8,2.4,9.8,5.4v51.1c0,2.9-4.4,5.4-9.8,5.4H50.4 C45,115.9,40.6,113.5,40.6,110.4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.6,168.9v-36c0-2.1,4.9-3.8,10.9-3.8h87.2c6,0,10.9,1.7,10.9,3.8v36c0,2.1-4.9,3.8-10.9,3.8H50.4 C44.4,172.6,39.6,171,39.6,168.9z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.3,204.8v-36c0-2.1,1.7-3.8,3.8-3.8h30.5c2.1,0,3.8,1.7,3.8,3.8v36c0,2.1-1.7,3.8-3.8,3.8h-30.5 C172.1,208.6,170.3,206.9,170.3,204.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 63.8,
    className: "st11",
    width: 67,
    height: 38.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1,
    y: 62.1,
    className: "st12",
    width: 67,
    height: 38.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 56.1,
    y1: 64.1,
    x2: 123.1,
    y2: 64.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 57.7,
    cy: 63.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 59.4,
    cy: 63.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 61.1,
    cy: 63.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,88.6c4.2-4.2,4.2-10.9,0-15.1c-2-2-4.7-3.1-7.5-3.1v10.6L97.1,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.6,70.4c-5.9,0-10.7,4.8-10.6,10.7c0,3.9,2.1,7.5,5.6,9.4l5.1-9.4V70.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.7,
    y: 90.2,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7,
    y: 90.2,
    className: "st1",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.6,
    y: 90.2,
    className: "st13",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.9,
    y: 90.6,
    className: "st1",
    width: 8.4,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.9,
    y: 91.6,
    className: "st1",
    width: 8.4,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.9,
    y: 92.6,
    className: "st1",
    width: 8.4,
    height: 0.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "105.6,107.8 105.8,108.9 106.5,109.3 107.4,109 108,109.3 108.1,108.2 107.1,107.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.2,108.6c0,0-0.7-0.8-0.7-0.4s-1.5,1.8-1.5,1.8s-2.4,0.7-0.5,1.2c1.8,0.4,5.9-0.9,6-1.1s-1.1-2.3-1.3-2.2 C108,108.1,107.3,108.7,106.2,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.5,95.3c0,0-0.3,2.1,0,2.4c0.3,0.3,0.1,0.9,0,1c-0.1,0.1,0.2,0.4,0.4,0.6c0.2,0.2,0.5,1,0.5,1 s1.2,3.2,1.2,3.5c0,0.3,0.5,1,0.5,1.2c0,0.2,0.3,0.9,0.3,1.1c0,0.1,0.6,1.3,0.4,1.5c-0.2,0.2-2.6,0.8-2.5,0.4s0.2-0.9,0.1-0.9 c-0.1,0-0.5-0.5-0.4-0.7c0.1-0.2-2.7-4.9-2.7-4.9L104.5,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M106.2,108.6c0,0-0.7-0.8-0.7-0.4s-1.5,1.8-1.5,1.8s-2.4,0.7-0.5,1.2c1.8,0.4,5.9-0.9,6-1.1s-1.1-2.3-1.3-2.2 C108,108.1,107.3,108.7,106.2,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.5,95.3c0,0-0.3,2.1,0,2.4c0.3,0.3,0.1,0.9,0,1c-0.1,0.1,0.2,0.4,0.4,0.6c0.2,0.2,0.5,1,0.5,1 s1.2,3.2,1.2,3.5c0,0.3,0.5,1,0.5,1.2c0,0.2,0.3,0.9,0.3,1.1c0,0.1,0.6,1.3,0.4,1.5c-0.2,0.2-2.6,0.8-2.5,0.4s0.2-0.9,0.1-0.9 c-0.1,0-0.5-0.5-0.4-0.7c0.1-0.2-2.7-4.9-2.7-4.9L104.5,95.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "99.9,107.2 99.4,108.5 99.6,110.2 101,110.1 101.9,109.4 101.9,107.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.1,108.7c0,0-0.5-1.6-0.8-1.2c-0.2,0.3-0.3,0.6-0.4,0.9c0,0-2.2,1.4-2.8,1.4s-1.1,0.7-0.4,1s6.6,0.6,6.7,0 s-0.1-2.6-0.4-2.4C101.9,108.7,100.5,109.2,100.1,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M99,88.8c0,0-0.9,1.6-1,1.8c-0.1,0.2-0.6,1.3,0.4,1.8s1.8-3.3,1.8-3.3L99,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100,86.2c0,0-1.4,2.8-1.2,2.9c0.3,0.1,1.3,0.6,1.3,0.6l0.5-2.8L100,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100,86.2c0,0-1.4,2.8-1.2,2.9c0.3,0.1,1.3,0.6,1.3,0.6l0.5-2.8L100,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.1,88.6c0,0-0.3,2.3-0.2,2.8c0.1,0.5-0.1,7.9,0.1,8.3c0.2,0.4,0.3,3,0.3,3.3s-0.4,2.9-0.4,3.1 s-0.4,1-0.2,1.3s2,1.3,2.2,0.9c0.3-0.3,0-1.3,0.3-1.3c0.2,0,0.5-2.2,0.5-2.2l1.5-8.3c0,0,2.8-6.9,2.2-7.6S100.1,88.6,100.1,88.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 101.8,
    cy: 70.4,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101,72.2c0,0,0.7,1.9,0.6,2.3s2.1-0.7,2.1-0.7s-0.1-2.2,0-2.8S101,72.2,101,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M107,84.5c0,0.4,0,0.6,0,0.6s0.1,2.1-0.1,2.7c-0.2,0.7-0.2,1.2-0.4,1.6c0,0.1-0.6,0.2-1.3,0.2 c-0.7,0-1.6,0-2.4,0c-1.4,0-2.7-0.1-2.9-0.1c-0.5-0.1,0.1-0.9-0.1-1.3c-0.2-0.4,0.3-5.6,0.3-5.6s0-2.9,0.2-4 c0.2-1.1,1.1-2.9,1.3-3.1c0.2-0.2,0-0.4-0.4-0.6c-0.4-0.3,0-1.3,0-1.3c0.8-0.6,2.7-0.7,2.7-0.7s3,3.1,3.1,3.7 c0.1,0.4,0.1,3.4,0,5.8C107,83.2,107,84,107,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M103.2,90.1c0,0-1.7,3.5-0.4,3.7c1.3,0.2,2-3.2,2-3.2L103.2,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.7,69.3c-0.1-0.4,0.2-0.7,0.5-1c0.7-0.5,1.5-0.8,2.3-0.8c0.6,0,1.2,0.2,1.6,0.5c0.5,0.4,0.8,1.2,0.7,1.9 c0,0.7-0.3,1.3-0.7,1.9c-0.2,0.3-0.5,0.5-0.8,0.4c-0.1-0.1-0.2-0.1-0.3-0.3c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.2-0.2-0.4-0.4-0.6 s-0.4-0.3-0.6-0.3c-0.2,0-0.4,0.2-0.6,0.1c-0.2-0.1-0.3-0.3-0.3-0.6c0-0.2,0-0.5-0.1-0.8C100.5,69.2,99.7,69.5,99.7,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M107,84.5c-0.5,1.8-1.7,4.9-1.7,5c0,0,0,0.1-0.1,0.2c-0.7,0-1.6,0-2.4,0c0.1-0.3,0.3-0.7,0.3-0.8 c0-0.2,1.1-6,1.1-6s-0.9-2.6-1.6-4.7c-0.8-2.2,2.3-1.7,2.3-1.7c1.6-0.4,1.9,0.3,1.9,0.3s0.1,3.8,0.3,5.6c0,0.5,0.1,0.8,0.2,0.9 C107.3,83.4,107.2,83.9,107,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M104.1,75c0,0-2.1,0.9-1.3,3c0.8,2.2,1.6,4.7,1.6,4.7s-1.1,5.8-1.1,6c0,0.2-0.7,1.4-0.4,1.7 c0.3,0.2,2.1,0.7,2.1,0.4c0.1-0.5,0.3-1,0.5-1.5c0.1-0.2,2.2-5.8,1.9-6.3c-0.3-0.5-0.5-6.5-0.5-6.5S105.8,74.6,104.1,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.6,92l-7.9-7.4l-4.7,9.7c1.6,0.9,3.3,1.3,5.1,1.3C95,95.5,97.6,93.9,99.6,92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.6,92l-7.9-7.4l-4.7,9.7c1.6,0.9,3.3,1.3,5.1,1.3C95,95.5,97.6,93.9,99.6,92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.9,92.5L91.4,85l-5.1,9.4C90.4,96.6,95.6,95.9,98.9,92.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 86.6,
    y1: 111.3,
    x2: 118.9,
    y2: 111.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 114.4,
    y1: 111.3,
    x2: 114.4,
    y2: 101.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 114.4,
    cy: 101.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.4,107.7c0,0-0.2-4.1-4.1-3.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M315.9,27.5c0.2,0.5,0.8,0.8,1.3,0.6c0.1,0,0.1,0,0.2-0.1l8.8,2.8l2.9-2.3l-11.3-2c-0.3-0.5-0.9-0.6-1.4-0.3 C315.9,26.5,315.8,27,315.9,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.2,31.2c0,0-0.1-0.2-1.1,0.2c-1.3,0.5-8.3,0.2-8.6-1.7c-0.3,0.3-0.7,0.3-1,0.1l1.1-2.4 c0.6-0.2,0.9-0.3,0.9-0.1l1.7-0.1l6.9,1.2l0.2,2.4L332.2,31.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "330,28.8 333.5,28.5 336.7,30 338.5,54.9 331.4,51.6 328.4,52.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "338.4,72.3 337.2,72.3 336.5,67.3 338.4,67.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M338.8,73.6l-4.2,0v-0.1c0-0.9,0.7-1.6,1.6-1.6h0l0.8-0.6l1.4,0.6l0.4,0L338.8,73.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "333.4,71.5 332.2,71.8 330.4,67 332.3,66.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334,72.6l-4.1,0.9l0-0.1c-0.2-0.9,0.4-1.7,1.2-1.9l0,0l0.6-0.7l1.5,0.3l0.4-0.1L334,72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M340.1,41.7c0.6,1.8,0.5,3.8-0.1,6l-0.3,12c0.5,0.5,0.6,5.3-0.2,6.9c-1,2.1-0.1,2.4-0.8,3.8h-2.1l-1-6.3 l-0.1-5.1c-0.3-0.6,0-2.9,0-2.9l-0.1-4.7l-3.7,8.3c1.7,1.4,1.5,6.1,1.6,8.1l0.6,2.4l-2.5,0.2l-1.1-3.3l-1.3-2 c-0.6-3.6-0.8-6.2-0.3-7.3l3.7-13.9L340.1,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.4,41.1l-0.3-0.7c-0.4-2.6-0.8-5-0.3-7.1c0-1.9-0.5-3.7-2.2-4.6l-0.7-0.4l-0.4-0.9l-3.4,0.1l0,1.2 l-1.2,1.9v0l0.1,10.6l0.3,1.1l-0.5,1.3l0.3,0.8l6.7-1.1l0.8-0.1c0.1,0,0.2-0.1,0.3-0.1c0.3-0.2,0.5-0.4,0.6-0.7c0,0,0,0,0-0.1 c0.1-0.1,0.1-0.3,0.1-0.4C340.5,41.6,340.5,41.3,340.4,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M340.5,41.8c0,0.1,0,0.3-0.1,0.4l-0.6,0.7c-0.1,0-0.2,0.1-0.3,0.1l-0.8,0.1l1.1-2.1l-2.5-5.4L340.5,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M287.8,63.7c-0.8,0-1.6,0-2.4-0.2c-0.7-0.1-1.1-0.3-1.1-0.5l0,0l1.4-10.3l-0.7-2c-0.1-0.3,0.1-0.6,0.3-0.7 c0.1,0,0.1,0,0.2,0l4.5,0c0.3,0,0.5,0.2,0.5,0.5c0,0.1,0,0.1,0,0.2l-0.6,1.9l1.4,10.3C291.3,63.6,289.1,63.7,287.8,63.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.3,
    y: 62.3,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.3,
    y: 61.5,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.3,
    y: 60.8,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.3,
    y: 60.1,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.3,
    y: 59.3,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M307.5,63.7c-0.8,0-1.6,0-2.4-0.2c-0.7-0.1-1.1-0.3-1.1-0.5l0,0l1.4-10.3l-0.7-2c-0.1-0.3,0.1-0.6,0.3-0.7 c0.1,0,0.1,0,0.2,0l4.5,0c0.3,0,0.5,0.2,0.5,0.5c0,0.1,0,0.1,0,0.2l-0.6,1.9L311,63C311,63.6,308.8,63.7,307.5,63.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 62.3,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 61.5,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 60.8,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 60.1,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 59.3,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.3,63.7c-0.8,0-1.6,0-2.4-0.2c-0.7-0.1-1.1-0.3-1.1-0.5l0,0l1.4-10.3l-0.7-2c-0.1-0.3,0.1-0.6,0.3-0.7 c0.1,0,0.1,0,0.2,0l4.5,0c0.3,0,0.5,0.2,0.5,0.5c0,0.1,0,0.1,0,0.2l-0.6,1.9l1.4,10.3C301.8,63.6,299.6,63.7,298.3,63.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.8,
    y: 62.3,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.8,
    y: 61.5,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.8,
    y: 60.8,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.8,
    y: 60.1,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.8,
    y: 59.3,
    className: "st0",
    width: 2.2,
    height: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.9,64.5h-4.2v-7h4.2c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9h-29.2c-0.5,0-0.9,0.4-0.9,0.9 c0,0.5,0.4,0.9,0.9,0.9h3.6v7h-3.6c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h29.2c0.5,0,0.9-0.4,0.9-0.9 C313.7,64.9,313.3,64.5,312.9,64.5C312.9,64.5,312.9,64.5,312.9,64.5z M289,64.5v-7h18v7H289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.2,73.6c-2.1,0-4.1-0.1-5.6-0.4c-1.8-0.3-2.7-0.8-2.7-1.4l0,0l3.2-24.5l-1.6-4.6c-0.2-0.4-0.1-0.9,0.2-1.3 c0.3-0.4,0.7-0.6,1.2-0.6l10.7,0.1c0.8,0,1.4,0.7,1.4,1.4c0,0.1,0,0.3-0.1,0.4l-1.5,4.5l3.2,24.5v0c0,0.7-1,1.1-3.1,1.4 C315.4,73.5,313.1,73.6,312.2,73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.2,73.6c-2.1,0-4.1-0.1-5.6-0.4c-1.8-0.3-2.7-0.8-2.7-1.4l0,0l3.2-24.5l-1.6-4.6c-0.2-0.4-0.1-0.9,0.2-1.3 c0.3-0.4,0.7-0.6,1.2-0.6l10.7,0.1c0.8,0,1.4,0.7,1.4,1.4c0,0.1,0,0.3-0.1,0.4l-1.5,4.5l3.2,24.5v0c0,0.7-1,1.1-3.1,1.4 C315.4,73.5,313.1,73.6,312.2,73.6z M306.8,41.1c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.3,0.7-0.2,1l1.6,4.7l0,0l-3.2,24.5 c0,0.2,0.3,0.7,2.5,1.1c1.5,0.2,3.4,0.4,5.6,0.4c1.9,0,3.8-0.1,5.2-0.3c1.8-0.3,2.8-0.7,2.8-1.1L317,47.3l1.5-4.6 c0.2-0.6-0.1-1.2-0.7-1.4c-0.1,0-0.2-0.1-0.3-0.1L306.8,41.1C306.8,41.1,306.8,41.1,306.8,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M318.3,68.8h-12.1l1.9-13l0.1-0.4l0.8-5.4c0-0.3,0.4-0.1,0.7-0.3c1.7-1.2,3.4-1.3,5.1-0.1 c0.3,0.2,0.6,0,0.7,0.3l0.8,5.4l0.1,0.5L318.3,68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M316.8,70.6h-9.2c-0.9,0-1.7-0.7-1.7-1.7c0-0.1,0-0.2,0-0.2l2.7-18.1c0-0.3,0.3-0.5,0.6-0.4 c0.1,0,0.2,0.1,0.3,0.1c1.6,1.3,3.4,1.3,5.3-0.1c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0.1,0.3,0.2,0.3,0.4l2.8,18.2 c0.1,0.9-0.5,1.8-1.4,1.9C316.9,70.6,316.8,70.6,316.8,70.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.9,
    y: 68.5,
    className: "st2",
    width: 5.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.9,
    y: 66.8,
    className: "st2",
    width: 5.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.9,
    y: 65,
    className: "st2",
    width: 5.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.9,
    y: 63.3,
    className: "st2",
    width: 5.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.9,
    y: 61.5,
    className: "st2",
    width: 5.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.5,56.9c-0.8,0.8-1.9,1.2-3.1,1.1c-0.6-0.1-1.2-0.3-1.8-0.6c-0.6-0.3-1.2-0.7-1.8-0.9 c-0.6-0.2-1.2-0.2-1.7,0.2c-0.1,0.1-0.2,0.1-0.3,0l0.1-0.4c0.5-0.4,1.2-0.4,1.9-0.3c1.3,0.3,2.3,1.3,3.6,1.5 c1.2,0.1,2.3-0.3,3.1-1.2l0,0L316.5,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.6,73.6c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0H283c-0.1,0-0.1-0.1-0.1-0.1s0.1-0.1,0.1-0.1h63.6 C346.6,73.5,346.6,73.5,346.6,73.6C346.6,73.6,346.6,73.6,346.6,73.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "333.4,28.5 336.9,28.2 340.1,29.7 341.9,54.6 334.8,51.3 331.8,52.2  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 316.5,
    cy: 27.9,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 315.5,
    cy: 35.2,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 312.3,
    cy: 39.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M327.3,44.8v-6.4c0-0.3,0.2-0.5,0.5-0.5h4.9c0.3,0,0.5,0.2,0.5,0.5v6.4c0,0.3-0.2,0.5-0.5,0.5h-4.9 C327.6,45.2,327.3,45,327.3,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M327.7,42.8v-4.1c0-0.3,0.2-0.5,0.5-0.5h4.2c0.3,0,0.5,0.2,0.5,0.5v5.7c0,0.3-0.2,0.5-0.5,0.5h-2.6 C328.6,44.9,327.7,43.9,327.7,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M328.4,39.8c0-0.2,0.2-0.4,0.5-0.5h2.9c0.2,0,0.5,0.2,0.5,0.5c0,0.2-0.2,0.5-0.5,0.5h-2.9 C328.6,40.3,328.4,40.1,328.4,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M328.4,41.2c0-0.2,0.2-0.4,0.5-0.5h2.9c0.2,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-2.9 C328.6,41.7,328.4,41.5,328.4,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M328.4,42.6c0-0.2,0.2-0.4,0.5-0.5h2.9c0.2,0,0.5,0.2,0.5,0.5c0,0.2-0.2,0.5-0.5,0.5h-2.9 C328.6,43.1,328.4,42.9,328.4,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M331.3,45.9c0.5-0.2,0.8-0.8,0.5-1.3c0-0.1-0.1-0.1-0.1-0.2l3.5-3.2l1.2-4.8l-2.2-0.2l-0.7,3.8l-3.4,4.1 c-0.5,0.3-0.6,1-0.2,1.4C330.4,45.9,330.9,46.1,331.3,45.9L331.3,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M336.9,32.1c0,0,0.5,0,0.3,1.1c-0.2,0.9-0.9,5.9-1.5,7c0.3,0.2,0.4,0.6,0.2,1l-2.4-0.9 c-0.2-0.6,0.1-0.7,0.4-0.8l0-1.7l0.4-4.4l2.4-1.2L336.9,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M337.6,23.9c-0.2,1.7-1.8,2.9-3.6,2.7c-1.7-0.2-2.9-1.8-2.7-3.6l0,0c0.3-1.7,1.9-2.9,3.6-2.6 C336.6,20.6,337.8,22.2,337.6,23.9L337.6,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.8,25.5c0.2-0.3,0.3-0.7,0.3-1.1c0-0.4-0.4-0.7-0.8-0.6c-0.2,0.1-0.4,0.3-0.6,0.3c-0.3,0-0.5-0.3-0.6-0.6 l-0.4-1.2c-0.7,0.6-1.7,0.8-2.6,0.6c-0.4-0.1-0.7-0.2-0.9-0.5s-0.2-0.8,0.1-1c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.2,0.2-0.5,0-0.7 c-0.1-0.1-0.3-0.2-0.5-0.2l1-0.1l-0.3-0.5c0.2,0.2,0.5,0.2,0.8,0.1c0.3,0,0.5-0.2,0.8-0.2c1.2-0.3,2.6,0.3,3.2,1.4 c0.5-0.2,1,0,1.3,0.4c0.3,0.3,0.3,0.8,0.3,1.2c0,0.8-0.2,1.6-0.5,2.4c-0.1,0.2-0.3,0.4-0.4,0.6c-0.2,0.2-0.4,0.3-0.7,0.2"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M446.8,151.3V54.1c0-5.7,4.4-10.3,9.9-10.3h79.7c5.5,0,9.9,4.6,9.9,10.3v97.2c0,5.7-4.4,10.3-9.9,10.3h-79.7 C451.3,161.3,446.8,156.9,446.8,151.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M490.5,96.9c1.3-1.2,1.7-3.3,1-4.5c-0.7-1.3-2.3-1.3-3.6-0.1s-3,4.6-2.3,5.9S489.2,98.1,490.5,96.9z  M486.1,97.5c-0.3-0.1-0.3-0.5-0.2-0.9s0.5-0.6,0.8-0.4c0.3,0.1,0.3,0.5,0.2,0.9S486.4,97.7,486.1,97.5L486.1,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M488.9,95.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.3-0.1-0.6-0.1-0.8 c0.1-0.4,0.3-0.8,0.5-1.1l0,0.3c0.1-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.4-0.1,0.5,0.1c0.1,0.2,0,0.5,0.1,0.7c0.2,0.3,0.8-0.3,1-0.1 c0.1,0.1,0.1,0.5,0,0.7c-0.1,0.3-0.2,0.7-0.3,1c-0.3,0.5-0.8,0.8-1.1,0.7C489.1,96.1,489,96,488.9,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M487.9,96c-0.1-0.2,0.1-0.5,0.2-0.7l0.1-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.3,0.1,0.3,0.2 c0,0.1,0,0.3,0.1,0.4c0.2,0.1,0.5-0.3,0.7-0.1c0.1,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.2,0-0.4,0.1-0.6,0.1 c-0.1,0-0.2,0-0.4,0C488,96.2,487.9,96.1,487.9,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M487.2,96.1c0-0.3,0.3-0.8,0.5-1.3l0.1-0.1c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.2,0,0.2,0.2 c0,0.2-0.1,0.5-0.1,0.6c0.1,0.2,0.6-0.7,0.7-0.5c0,0.1-0.1,0.5-0.3,0.7c-0.1,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.3-0.6,0.5 c-0.1,0.1-0.2,0.2-0.3,0.2C487.2,96.4,487.2,96.3,487.2,96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M487.2,97.3c-0.1-0.5-0.6-0.9-1.2-0.8c-0.1,0-0.1,0-0.2,0.1l-2.3-2.7l-0.5,1.8l2.3,2.3 c0.2,0.5,0.8,0.7,1.4,0.5C487.1,98.2,487.3,97.8,487.2,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.5,87l-0.6,1.1c0,0,1.6,0.8,1.7,1.5c0,0.6,0.1,0.5,0.4,0.7s0.5,0.6,0.5,1.1s3.9,4.4,3.9,4.4l-1.1,1.5 c-0.3-0.3-0.7-0.6-1.1-0.8c-0.6-0.3-2.4-0.9-2.5-1.3c-0.1-0.3-0.6-0.6-1.1-0.9c-0.5-0.4,0.6-0.7-0.3-1.2c-0.8-0.6-5.2-5.2-6-5.6 c-0.8-0.4-0.8-1.8-0.8-1.8l0.6-0.8L479.5,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M514.8,114.5V114c0-0.2,0-0.3,0-0.5v-42c0-0.5-0.4-1-1-1s-1,0.4-1,1v42c0,0.2,0,0.3,0,0.5v0.5l-10,20.4 c1,1,2.6,1,3.6,0c0,0,0,0,0,0l6.4-16.2v15.9c0,0.5,0.4,1,1,1s1-0.4,1-1l0,0v-15.9l6.4,16.2c1,1,2.6,1,3.6,0c0,0,0,0,0,0 L514.8,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M465.7,129.6c-1.1-1.1-2-2.3-2.7-3.6c-0.7-1.3-1.3-2.7-1.6-4.2c-0.3-1.5-0.4-3-0.3-4.5c0.2-3.1,1.4-6,3.3-8.5 c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.2,0.4,0.1,0.2,0.2c-1.9,2.3-3.2,5.2-3.5,8.2c-0.5,4.7,1.1,9.3,4.5,12.6 C466.1,129.5,465.9,129.7,465.7,129.6L465.7,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M464.2,109.1c0.1,0,0.3-0.1,0.4-0.2c0,0,0,0,0,0L464.2,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M466.8,106.2c-0.1,0.3-0.2,0.6-0.3,0.9c-0.4,0.8-1,1.4-1.7,1.8c0,0-0.1,0-0.1,0.1c-0.1-0.1-0.1-0.2-0.2-0.2 c-0.3-0.5-0.6-1.1-0.8-1.7c-0.2-0.7-0.1-1.5,0.4-2.1c0.5-0.6,1.3-0.8,2-0.5c0.2,0.1,0.3,0.3,0.5,0.4c-0.1,0.1-0.1,0.2-0.2,0.2 c0,0,0,0,0,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.3-0.5,0.6-0.7,0.8c0.3,0.1,0.7,0.1,1,0.1c0,0,0.1,0,0.1,0 C466.6,106.2,466.7,106.2,466.8,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M462.1,111.8L462,113l0,0.3c0,0-0.1,0-0.1,0c-1.7-0.9-3-2.4-3.5-4.3c-0.1-0.3-0.1-0.6-0.2-1 c0.4-0.1,0.9-0.1,1.3-0.2c-0.4-0.5-0.8-0.9-1.3-1.1c0.1-1.1,0.5-2.2,1.2-3.2c0.1,1.9,2.1,3.1,2.9,4.9 C462.8,109.5,462.7,110.8,462.1,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M461.7,121.9c-0.1,0-0.2,0-0.3,0c-1.8,0-3.6-0.8-4.9-2.1c-0.5-0.6-0.9-1.2-1.2-1.9c0,0,0,0,0,0 c0.4-0.1,0.9-0.1,1.3-0.2c-0.5-0.6-1.1-1.1-1.8-1.4c-0.1-0.6-0.1-1.3,0-1.9c1,1.6,3.4,1.8,4.8,3c0.7,0.6,1.2,1.4,1.4,2.3 c0,0.2,0.1,0.5,0.1,0.7c0,0.1,0,0.1,0,0.2l0,0.1L461.7,121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M466.2,123.8c-0.3,0.3-0.6,0.7-0.9,1c0.3,0.1,0.7,0.1,1.1,0.1c-0.3,1.1-0.9,2.2-1.8,3 c-0.1,0.1-0.2,0.2-0.2,0.2c0,0,0,0-0.1,0l-0.1-0.2l0,0l-0.4-1.2c-0.5-0.5-0.9-1.2-1.1-2v0c-0.1-0.4-0.1-0.9-0.1-1.3 c0.2-1.9,1.8-3.6,1.4-5.5c0.9,0.7,1.6,1.6,2,2.7c-0.2,0.3-0.5,0.6-0.7,0.8c0.3,0.1,0.7,0.1,1,0.1c0.1,0.5,0.2,0.9,0.2,1.4 c0,0.1,0,0.1,0,0.2C466.5,123.4,466.3,123.6,466.2,123.8C466.2,123.8,466.2,123.8,466.2,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M521.9,133.2c-0.2-1.5-0.1-3,0.1-4.5c0.3-1.5,0.7-2.9,1.4-4.3c0.7-1.4,1.5-2.6,2.6-3.7 c2.1-2.3,4.9-3.8,7.9-4.6c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.2,0.3,0,0.3c-3,0.6-5.7,2-7.8,4.2c-3.3,3.3-4.9,8-4.4,12.6 C522.3,133.4,521.9,133.5,521.9,133.2L521.9,133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M533.6,116.3c0.1,0,0.3,0.1,0.4,0.1c0,0,0,0,0,0L533.6,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M537.4,115.7c-0.2,0.2-0.5,0.4-0.8,0.5c-0.8,0.4-1.6,0.5-2.5,0.3c0,0-0.1,0-0.1,0c0-0.1,0-0.2,0-0.3 c0.1-0.6,0.2-1.2,0.5-1.8c0.3-0.7,0.9-1.2,1.6-1.4c0.7-0.2,1.6,0.2,1.8,0.9c0.1,0.2,0.1,0.4,0.1,0.6c-0.1,0-0.2,0-0.3,0.1 c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0.1c-0.4,0.1-0.7,0.2-1.1,0.2c0.2,0.2,0.5,0.5,0.7,0.7c0,0,0,0,0.1,0 C537.2,115.6,537.3,115.6,537.4,115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M530.2,117.2l-0.8,0.8l-0.2,0.2c0,0,0-0.1,0-0.1c-0.8-1.8-0.8-3.8,0-5.5c0.1-0.3,0.3-0.6,0.5-0.9 c0.4,0.2,0.8,0.5,1.2,0.7c0-0.6-0.1-1.2-0.3-1.7c0.8-0.8,1.8-1.4,2.9-1.7c-1.1,1.6-0.3,3.8-0.9,5.6 C532.2,115.8,531.4,116.7,530.2,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M523.6,124.8c-0.1-0.1-0.2-0.1-0.3-0.2c-1.4-1.2-2.3-2.9-2.5-4.7c0-0.7,0-1.5,0.2-2.2c0,0,0,0,0,0 c0.4,0.2,0.8,0.5,1.2,0.7c0-0.8-0.2-1.5-0.5-2.2c0.3-0.5,0.7-1,1.2-1.5c-0.2,1.9,1.5,3.5,1.9,5.4c0.2,0.9,0,1.8-0.4,2.7 c-0.1,0.2-0.2,0.4-0.4,0.6c0,0-0.1,0.1-0.1,0.1l0,0.1L523.6,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M525.9,129c-0.4,0.1-0.9,0.2-1.3,0.3c0.2,0.3,0.5,0.5,0.8,0.7c-1,0.7-2.1,1.1-3.2,1.2c-0.1,0-0.2,0-0.3,0 c0,0,0,0-0.1,0l0.1-0.2l0,0l0.4-1.2c-0.1-0.8,0.1-1.5,0.4-2.2l0,0c0.2-0.4,0.5-0.8,0.8-1.1c1.4-1.3,3.7-1.7,4.6-3.4 c0.2,1.1,0.2,2.3-0.1,3.4c-0.4,0.1-0.7,0.2-1.1,0.2c0.2,0.2,0.5,0.5,0.7,0.7c-0.2,0.4-0.5,0.8-0.7,1.2c0,0.1-0.1,0.1-0.1,0.2 C526.4,128.9,526.2,129,525.9,129C525.9,129,525.9,129,525.9,129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M532,107.5h-36.4c-0.9,0-1.6-0.7-1.6-1.6V80.5c0-0.9,0.7-1.6,1.6-1.6H532c0.9,0,1.6,0.7,1.6,1.6v25.5 C533.6,106.8,532.9,107.5,532,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M519.2,80.5h-10.8c-1.4,0-2.6-1.2-2.6-2.6v0h15.9v0C521.8,79.3,520.6,80.5,519.2,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M519.2,109.1h-10.8c-1.4,0-2.6-1.2-2.6-2.6v0h15.9v0C521.8,108,520.7,109.1,519.2,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M516.6,102.6c0,1.6-1.2-0.2-2.7-0.2c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8 C515.4,96.8,516.6,101.1,516.6,102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M505.8,88.6c0,1.6-1.3,2.8-2.8,2.8s-2.3,3.1-2.3,1.6c0-1.6,0.8-7.2,2.3-7.2S505.8,87,505.8,88.6L505.8,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502.1,85.5c0.4-0.2,0.9-0.2,1.3,0.1c0.4,0.3,0.7,0.7,0.8,1.2c0.1,0.5,0.1,1.1,0,1.6c-0.1,0.5-0.4,1.1-0.9,1.2 c-0.4,0.1-0.8,0-0.9-0.4c-0.1-0.3,0-0.6,0.2-0.9c0.3-0.3,0.8-0.4,1.2-0.2c0.5,0.2,0.8,0.7,0.9,1.1c0.1,0.6,0.1,1.2-0.1,1.7 c-0.2,0.6-0.4,1.2-0.6,1.8c-0.4,1.2-0.7,2.4-0.8,3.6c-0.1,1.9,0.5,4.1,2.2,5.1c0.9,0.5,2,0.6,3.1,0.4c1.1-0.2,2.1-0.8,2.9-1.5 c0.4-0.4,0.9-0.8,1.2-1.2c0.2-0.3,0.6-0.4,1-0.3c0.9,0.3,0.7,1.7-0.2,1.9c-0.4,0.1-0.8-0.1-1.1-0.4c-0.3-0.3-0.6-0.7-0.7-1.1 c-0.2-0.9,0-1.9,0.6-2.6c0.6-0.8,1.6-1.4,2.5-1.7c1.1-0.4,2.3-0.5,3.4-0.6c1.2-0.1,2.4-0.3,3.5-0.7c0.9-0.3,1.7-0.8,2.4-1.4 c1.5-1.2,2.5-2.9,3-4.8c0.1-0.4,0.2-0.9,0.2-1.4c0-0.2-0.3-0.2-0.3,0c-0.1,2-1.1,3.9-2.5,5.3c-0.7,0.7-1.5,1.3-2.4,1.7 c-1.1,0.5-2.3,0.7-3.5,0.8c-1.2,0.1-2.4,0.2-3.6,0.5c-1,0.3-2.1,0.8-2.8,1.7c-0.6,0.7-1,1.8-0.8,2.7c0.1,0.9,0.7,1.8,1.6,2 c0.4,0.1,0.9,0,1.2-0.4c0.3-0.4,0.4-1,0.2-1.5c-0.3-0.5-0.9-0.8-1.5-0.5c-0.2,0.1-0.4,0.2-0.5,0.4c-0.8,0.9-1.7,1.7-2.8,2.2 c-1,0.5-2.2,0.6-3.3,0.3c-2.1-0.7-2.9-3-2.7-5c0.1-1.3,0.5-2.6,0.9-3.8c0.2-0.6,0.4-1.3,0.6-1.9c0.1-0.6,0.2-1.2,0-1.8 c-0.2-0.5-0.5-0.9-1-1.2c-0.4-0.2-1-0.2-1.4,0.1c-0.6,0.4-0.6,1.5,0.1,1.8c0.5,0.2,1,0,1.4-0.3c0.4-0.4,0.5-1,0.6-1.5 c0.1-1-0.1-2.3-1.2-2.8c-0.4-0.2-0.9-0.2-1.4,0c-0.1,0-0.1,0.1,0,0.2C501.9,85.5,502,85.5,502.1,85.5L502.1,85.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M527.3,86.8c0,1.6,2.6,5.8,1.7,7.1c-0.1,0.2-0.2,0.3-0.3,0.5c-0.4,0.5-0.8,0.9-1.3,1.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3,0.2-0.6,0.4-1,0.6c-0.1,0-0.1,0.1-0.2,0.1c-3.9,1.9-8.6,0.2-10.4-3.7c-1.4-3-0.8-6.6,1.6-9 c0.1-0.1,0.1-0.1,0.2-0.2c0.7-0.7,1.6-1.2,2.5-1.5c0,0,0,0,0,0c1.4-0.5,2.9-0.6,4.3-0.4h0c0,0,0.1,0,0.1,0 C527.7,82.6,527.3,83,527.3,86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.1,96.4C526.1,96.4,526.1,96.4,526.1,96.4c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.1 c0-0.1,0-0.3-0.1-0.4c-0.4-1.2-1.6-1.8-2.8-2c-1.4-0.3-2.8-0.2-4.1-0.7c-0.5-0.2-1-0.6-1.4-1c-0.4-0.5-0.6-1.1-0.5-1.7 c0.1-1.5,1.1-2.6,1.5-4c0.1-0.6,0.1-1.2-0.1-1.7c-0.2-0.5-0.6-0.9-1.1-0.9c0,0-0.1,0-0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2 c0.1,0,0.2,0,0.3,0.1c0.5,0.2,0.9,0.6,1.1,1.1c0.2,0.6,0.2,1.2,0,1.8c-0.4,1.4-1.5,2.6-1.4,4.1c0,1.3,1.2,2.1,2.3,2.4 c1.4,0.4,2.9,0.2,4.3,0.7C525,94.3,526,95.2,526.1,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M527.3,95.7c-0.1,0.1-0.2,0.1-0.3,0.2c0,0,0-0.1,0-0.1c0-1.2-0.4-2.4-1.2-3.3c-0.3-0.4-0.8-0.7-1.2-1 c-0.5-0.3-1-0.4-1.5-0.6c-0.5-0.2-1-0.4-1.4-0.8c-0.4-0.4-0.6-0.9-0.7-1.5c-0.1-1.3,0.5-2.5,0.6-3.8c0-0.6-0.1-1.1-0.5-1.6 c-0.3-0.4-0.8-0.7-1.3-0.6c-0.2,0-0.2-0.2,0-0.3c0,0,0,0,0,0c0.6-0.1,1.1,0.3,1.5,0.7c0.4,0.5,0.6,1.2,0.5,1.8 c-0.1,1.3-0.8,2.5-0.5,3.8c0.1,0.6,0.4,1,0.8,1.4c0.5,0.3,1,0.4,1.6,0.6c0.5,0.2,1,0.4,1.5,0.7c0.4,0.3,0.8,0.7,1.1,1.2 C527,93.5,527.4,94.6,527.3,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M529,93.9c-0.1,0.2-0.2,0.3-0.3,0.5c0.1-0.7,0.1-1.5-0.1-2.2c-0.2-0.9-0.7-1.7-1.3-2.4 c-0.3-0.3-0.7-0.6-1.1-0.9c-0.5-0.3-1-0.5-1.3-0.9c-0.7-1-0.2-2.2,0-3.2c0.1-0.5,0.2-1.1,0-1.6c-0.2-0.4-0.5-0.8-1-0.8 c-0.2,0-0.2-0.3,0-0.3c0,0,0.1,0,0.1,0c0.5,0.1,0.9,0.5,1.1,0.9c0.3,0.6,0.2,1.2,0.1,1.9c-0.2,1-0.8,2.4,0.2,3.2 c0.4,0.4,0.9,0.5,1.3,0.9c0.4,0.3,0.7,0.6,1,1C528.7,91,529.1,92.4,529,93.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "478.7,132.7 480.4,132.7 481.2,126.3 478.7,126.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M477.9,135.6h1.2l0.2-1.1l0.5,1.1h3.2c0.4,0,0.7-0.3,0.7-0.7c0-0.2-0.1-0.5-0.3-0.6l-2.5-1.7v-1.1l-2.7,0.2 L477.9,135.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "465.8,129.4 467.3,130.3 471.2,125.2 469.1,123.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M463.6,131.4l1,0.6l0.8-0.9l-0.1,1.2l2.7,1.6c0.3,0.2,0.8,0.1,1-0.2c0.1-0.2,0.1-0.4,0-0.7l-1.3-2.8l0.6-1 l-2.4-1.2L463.6,131.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "478.9,91.7 480.3,96.9 472.6,97 473.6,92  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M480.3,96.8l1.6,5.3l0.7,14.2l-1.9,13.6h-2.1l-0.8-13.3l-2.1-9.1l1.2,9.6l-6.4,9.3h-3.1l5.8-10.3l-3.4-10.7 c0,0,0.3-5.3,2.5-8.1l0.5-1.5L480.3,96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.4,87c0,0,0-0.1,0-0.1c-0.3-2.3-2.5-3.9-4.8-3.6c-1,0.2-2,0.7-2.7,1.5v0c0,0-0.1,0.1-0.1,0.1 c-0.1,0.1-0.1,0.2-0.2,0.2c-0.5,0.7-0.7,1.6-0.7,2.4c0,0,0.4,2.1,0.5,2.7c0.1,0.4,0.1,0.7,0.1,1.1c0,0.2,0,0.4,0,0.5v0 c0.1,0.8,0.1,1.6,0.1,2.2c0,0.3,0.2,1.2,0.2,1.2c0,0,0,0,0,0c0.2,0.1,0.5,0.1,0.7,0l1-0.5l0,0c0.7-0.3,1.4-0.4,2.1-0.3 c1.2,0.2,2.9,0.4,3,0.3c0.1-0.1,0.5-4.1,0.7-5.3c0-0.2,0-0.4,0-0.6v0C480.5,88.3,480.5,87.6,480.4,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M486.1,87.7c-0.2,0.5-0.7,0.8-1.2,0.6c-0.1,0-0.1,0-0.2-0.1l-2.5,2.3l-0.3-1.7l2.4-1.9 c0.3-0.4,0.9-0.6,1.3-0.3C486.1,86.8,486.3,87.3,486.1,87.7L486.1,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.8,83.3c0,0,2.5,0.5,1.1,5.3l0.5,2.4l2.6-1.5l0.2-0.6l2.2-1.6l1.1,1.9l-1.3,1.2l-0.4,0.8l-0.7,0.2l-2,2 l-0.9,0.5c0,0-1.1,0.7-2.1,0.3c-0.3-0.1-0.5-0.2-0.7-0.4c-0.4-0.3-0.8-0.9-1-1.6c-0.9-2.9-1.2-4.9-1.2-4.9L476.8,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M485.9,90.1l-1.5-5.6c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0,0.1,0.1l2,5.3L485.9,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.2,91.3c-0.2,0-0.4-0.1-0.6-0.2c-0.1,0-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1 c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.2,0.4-0.3,0.6-0.5l0.1-0.1 c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.2,0.4c0,0,0,0.1,0,0.1c0,0.1-0.1,0.3-0.2,0.4c0,0,0,0.1,0,0.1c-0.1,0.2,0,0.4,0.1,0.5 C487,91.2,487.1,91.3,487.2,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M487.5,91.4c-0.1,0-0.2,0-0.3-0.1C487.3,91.4,487.4,91.4,487.5,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M487.2,91.3c-0.2,0-0.4-0.1-0.6-0.2c-0.1,0-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1 c0,0,0.1-0.1,0.1-0.1c0.3-0.3,0.7-0.5,1.1-0.6c0,0,0,0.1,0,0.1c0,0.1-0.1,0.3-0.2,0.4c0,0,0,0.1,0,0.1c-0.1,0.2,0,0.4,0.1,0.5 C487,91.2,487.1,91.3,487.2,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M537.1,135.6c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0h-80.7c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.1,0.1-0.1H537 C537.1,135.5,537.1,135.6,537.1,135.6C537.1,135.6,537.1,135.6,537.1,135.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 475.6,
    cy: 79.3,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M473.7,76.7L473.7,76.7c0,0.1,0,0.3-0.1,0.4c0,0,0,0,0,0.1v0c-0.2,0.5-0.5,0.9-1,1.1c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0 c-0.8-0.4-1.2-1.3-0.9-2.2c0,0,0-0.1,0-0.1l0,0c0.1-0.2,0.2-0.3,0.3-0.5c0.3-0.3,0.4-1,0.9-1c0,0,0,0,0.1,0c0.3,0,0.9,0.7,1.1,0.8 c0.2,0.1,0.3,0.3,0.5,0.4c0.1,0.2,0.2,0.4,0.3,0.6C473.6,76.4,473.7,76.6,473.7,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M471.6,76.1c-0.3,0.3-0.7,0.4-1,0.6c-1.3,0.6-2.2,1.7-2.5,3.1c-0.1,0.6-0.1,1.1-0.2,1.7 c-0.2,0.5-0.5,1.1-1.1,1.2c-0.4,0.1-0.8-0.1-1.1-0.2c-0.2-0.1-0.4-0.2-0.6-0.2c0.2-0.5,0.4-1,0.6-1.5c-0.3,0.5-0.7,0.9-1.1,1.3 c-0.7-0.3-1.4-0.6-2.1-0.8c1.7,0,1.4-1.7,1.8-3.4c0.2-0.9,2-1.6,2.4-2.4c0.6-1.4,2.1-2,3.5-1.5c0.6,0.2,1.1,0.7,1.4,1.2 C471.9,75.3,471.9,75.8,471.6,76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M478.6,76.1c-0.3-0.4-1.1-0.4-1.3,0.1l-0.3-0.5c-0.4-1-1.6-0.8-2.6-0.6c-1,0.1-2,0.9-2.4,1.8 c-0.5,0.9-0.5,2.1-0.2,3.1c0.2,0.7,0.5,1.3,1.1,1.8c0.5,0.4,3.1,1.5,3.3,0.6c-0.3,1.2,0.3,1,1.1,1.9c0.4-1.2,0.6-3.6,1-4.8 c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.4,0.3-0.8,0.4-1.2C478.8,77.1,478.9,76.5,478.6,76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M476.4,79.7l-0.1-0.9c0.1-1.1-0.1-2.8,0.7-3.1l0.4,0.4C477.1,76.2,476.6,77.9,476.4,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M477.5,75c0,0.7-0.2,1.2-0.5,1.2c-0.3,0-0.5-0.5-0.5-1.2s0.5-1.2,0.5-1.2S477.5,74.3,477.5,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M477.9,75.3c-0.3,0.6-0.7,1-1,0.9c-0.3-0.1-0.3-0.7,0-1.3c0.3-0.6,1-0.9,1-0.9S478.2,74.7,477.9,75.3z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M435.9,167.6V36.9c0-3.1,2.7-5.6,5.9-5.6h108.6c3.3,0,5.9,2.5,5.9,5.6v130.7c0,3.1-2.7,5.6-5.9,5.6H441.7 C438.5,173.2,435.9,170.7,435.9,167.6z M441.7,32.6c-2.5,0-4.5,1.9-4.6,4.4v130.7c0,2.4,2,4.3,4.6,4.4h108.6c2.5,0,4.5-1.9,4.5-4.4 V36.9c0-2.4-2-4.3-4.5-4.4L441.7,32.6L441.7,32.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.4a4cdafefdfa87e780c11d56ffc4fa3c.svg";
export { ForwardRef as ReactComponent };